<template>
  <div class="team-form-page page-content users-table-view">
    <div class="container-fluid bracket-custom-style">
      <Affix :offset-top="0">
        <Card class="header-card">
          <div class="register-header-card">
            <div class="mb-2 mb-sm-0">
              <div class="d-flex align-items-center flex-wrap">
                <span class="page-title">{{ $t("global.register") }}</span>
                <span class="page-title" v-if="competition">{{
                  competition.name
                }}</span>
              </div>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <div v-if="competition && competition.notes.text">
                <Poptip
                  class="mr-2"
                  trigger="hover"
                  word-wrap
                  :content="competition.notes.text"
                >
                  <Button type="dashed" size="large"
                    ><b>{{ $t("competition.notes") }}</b></Button
                  >
                </Poptip>
              </div>

              <Poptip
                class="mr-2"
                v-if="competition"
                trigger="hover"
                word-wrap
                :content="
                  $moment(competition.date[0]).format('DD.MM.YYYY') +
                    ' - ' +
                    $moment(competition.date[1]).format('DD.MM.YYYY')
                "
              >
                <Button type="dashed" size="large"
                  ><b>{{ $t("club.table.date") }}</b></Button
                >
              </Poptip>

              <Poptip class="mr-2" v-if="competition" trigger="hover">
                <Button type="dashed" size="large"
                  ><b>{{ $t("competition.stages") }}</b></Button
                >
                <div class="api" slot="content">
                  <div class="d-flex flex-column flex-wrap">
                    <template v-for="stage in competition.stages">
                      <h6 :key="stage._id" style="line-height: 1.5rem;">
                        {{
                          stage.name +
                            " - " +
                            $moment(stage.date_start).format("DD.MM.YYYY")
                        }}
                      </h6>
                    </template>
                  </div>
                </div>
              </Poptip>
              <Button
                type="warning"
                :disabled="checkIfCompetitionStarted"
                size="large"
                @click="onSubmit"
              >
                <b>{{ $t("global.save") }}</b>
              </Button>
            </div>
          </div>
        </Card>
      </Affix>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Row v-else-if="checkIfCompetitionStarted" style="margin-top: 20px;">
        <Col span="24">
          <Card
            class="d-flex flex-column align-items-center justify-content-center"
          >
            <h2 class="text-center">{{ $t("global.register_closed") }}</h2>
            <h4 class="text-center">
              {{ $t("global.register_closed_details") }}
            </h4>
          </Card>
        </Col>
      </Row>
      <Row v-else style="margin-top: 20px;">
        <Col span="24">
          <div>
            <Form>
              <Card>
                <div
                  class=" d-flex align-items-start justify-content-between"
                  style="padding: 10px 0;"
                >
                  <div
                    class="d-flex flex-column align-items-start justify-content-between w-100 alert-competition-block"
                    style="overflow-x: scroll;"
                  >
                    <Alert
                      v-if="checkIfCompetitionStarted"
                      type="error"
                      class="alert-competition-started"
                    >
                      <Icon
                        type="md-close-circle"
                        color="red"
                        class="mr-3"
                        size="20"
                      />
                      <b>{{ $t("global.register_closed") }}</b>
                    </Alert>
                    <div v-else>
                      <h5 class="mb-4">{{ $t("competition.choose_age") }}</h5>
                      <!-- <Select @on-select="onSelectCategory" @on-change="onChangeCategory" v-model="catvals" :placeholder="$t('global.category')" filterable multiple>
                          <Option v-for="category in categories" :value="category._id" :key="category._id">
                            {{ category.name }}
                          </Option>
                      </Select> -->
                      <CheckboxGroup
                        v-model="catvals"
                        @on-change="onSelectCategoryCheck"
                        class="d-flex"
                      >
                        <Checkbox
                          v-for="category in categories"
                          :value="category._id"
                          :key="category._id"
                          :label="category._id"
                          :disabled="
                            disabledCheckBox(category) ||
                              checkIfCompetitionStarted
                          "
                          class="category-checkbox"
                        >
                          <b>{{ category.name }}</b>
                        </Checkbox>
                      </CheckboxGroup>
                    </div>
                  </div>
                  <!-- <Button type="success" size="large" @click="onSubmit">{{ $t('global.save') }}</Button> -->
                </div>
              </Card>

              <div class="border-top w-auto">
                <template v-if="cats.length" v-for="(cat, j) in cats">
                  <Card class="mb-4 mt-4">
                    <div class="team-box mb-4">
                      <h1>{{ cat.category.name }}</h1>
                      <Button
                        @click="() => onIncreaseTeamQty(j)"
                        class="font-size-18 pb-2"
                        :disabled="
                          competition.formats.some(
                            format =>
                              format.format_type &&
                              format.category._id === cat.category._id
                          )
                        "
                        >+</Button
                      >
                    </div>
                    <div>
                      <div
                        class="d-flex align-items-start"
                        style="overflow-x: scroll; gap: 16px;"
                      >
                        <template v-for="(item, i) in cat.teams">
                          <div
                            class="d-flex flex-column justify-content-start team-box-item"
                          >
                            <div
                              class="text-center"
                              :class="
                                item.players.length >=
                                competition.ttype.max_count
                                  ? 'green'
                                  : 'yellow'
                              "
                              style="height: 25px; width: 100%;"
                            >
                              <b style="color: #ffffff">{{
                                $t("competition.minim_players", {
                                  fact: item.players.length,
                                  min: competition.ttype.max_count
                                })
                              }}</b>
                            </div>
                            <div
                              class="w-100 d-flex justify-content-between align-items-start flex-column"
                            >
                              <div class="h-fix">
                                <div
                                  class="d-flex align-items-center w-100 justify-content-between"
                                  v-if="item.nameStatus"
                                >
                                  <div class="d-flex align-items-center ">
                                    <h3 class="w-auto ">{{ item.name }}</h3>
                                    <Button
                                      @click="() => teamNameState(j, i, false)"
                                      class="edit-icon ml-3"
                                      type="dashed"
                                      icon="ios-create"
                                      :disabled="checkIfCompetitionStarted"
                                    ></Button>
                                    <!-- <Icon type="ios-create" class="edit-icon mb-3" @click="() => teamNameState(j, i, false)"  /> -->
                                  </div>
                                  <Button
                                    v-if="item._id"
                                    @click="() => deleteTeam(item._id)"
                                    type="error"
                                    icon="md-trash"
                                    :disabled="
                                      competition.formats.some(
                                        format => format.format_type
                                      )
                                    "
                                  />
                                  <Button
                                    v-else
                                    @click="removeNewTeam(cat.teams, i)"
                                    type="error"
                                    icon="md-trash"
                                    :disabled="checkIfCompetitionStarted"
                                  ></Button>
                                </div>
                                <div v-else class="d-flex player-comp-style">
                                  <Input
                                    type="text"
                                    v-model="item.name"
                                    :placeholder="$t('competition.team_name')"
                                    :readonly="item.nameStatus"
                                    class="team-input"
                                  >
                                    <!-- <template #append>
                                    <Button icon="md-checkmark-circle" @click="() => teamNameState(j, i, true)"></Button>
                                  </template> -->
                                  </Input>
                                  <ButtonGroup
                                    class="d-flex player-button-style"
                                  >
                                    <Button
                                      icon="md-checkmark-circle"
                                      @click="() => teamNameState(j, i, true)"
                                      :disabled="checkIfCompetitionStarted"
                                    ></Button>
                                    <Button
                                      @click="removeNewTeam(cat.teams, i)"
                                      type="error"
                                      icon="md-trash"
                                      :disabled="checkIfCompetitionStarted"
                                    ></Button>
                                  </ButtonGroup>
                                </div>
                              </div>
                              <div class="mt-3 w-100">
                                <!-- <Select
                                  :placeholder="$t('global.kiezen')"
                                  filterable
                                  clearable
                                  :disabled="checkIfCompetitionStarted"
                                >
                                  <Option value="">{{
                                    $t("global.kiezen")
                                  }}</Option>
                                  <Option
                                    v-for="license in licenseFilter(
                                      cat.category,
                                      cat.licenses
                                    )"
                                    :value="license._id"
                                    :disabled="true"
                                    :key="license._id"
                                    class="disabled-referee"
                                  >
                                    <div
                                      class="d-flex align-items-center justify-content-between"
                                      style="100%"
                                    >
                                      <span
                                        class="d-flex align-items-center justify-content-between w-100 position-relative"
                                      >
                                        <b
                                          >{{ license.firstName }}
                                          {{ license.secondName }}</b
                                        >
                                        <Poptip
                                          v-if="checkMedicalControl(license)"
                                          trigger="hover"
                                          transfer
                                          class="mr-2"
                                        >
                                          <Icon
                                            type="md-alert"
                                            color="red"
                                            size="20"
                                          />
                                          <div slot="content">
                                            <Alert
                                              class="medical-control-style"
                                              type="error"
                                              >{{ $t("user.medical_control") }}
                                            </Alert>
                                          </div>
                                        </Poptip>
                                      </span>
                                      <Button
                                        @click="
                                          () =>
                                            addPlayer(
                                              j,
                                              i,
                                              license._id,
                                              cat.licenses
                                            )
                                        "
                                        type="success"
                                        icon="md-add"
                                        :disabled="
                                          checkIfCompetitionStarted ||
                                            checkMedicalControl(license)
                                        "
                                      ></Button>
                                    </div>
                                  </Option>
                                </Select> -->
                                <PlayerSelector
                                  v-if="cat"
                                  :checkIfCompetitionStarted="
                                    checkIfCompetitionStarted
                                  "
                                  :licenseFilter="
                                    () =>
                                      licenseFilter(cat.category, cat.licenses)
                                  "
                                  :checkMedicalControl="checkMedicalControl"
                                  :addPlayer="
                                    e => addPlayer(j, i, e, cat.licenses)
                                  "
                                />
                              </div>
                            </div>

                            <table
                              id="users-table"
                              class="table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
                            >
                              <thead class="positionThead">
                                <tr>
                                  <th>{{ $t("club.table.name") }}</th>
                                  <th>{{ $t("club.table.number") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-for="(player, idx) in item.players">
                                  <tr v-if="player" :key="player._id">
                                    <td>
                                      {{ player.player.firstName }}
                                      {{ player.player.secondName }}
                                    </td>
                                    <td v-if="player.jerseyStatus">
                                      {{ player.jersey_number }}
                                    </td>
                                    <td v-else>
                                      <div class="d-flex player-comp-style">
                                        <Input
                                          type="number"
                                          class="w-fit"
                                          v-model="player.jersey_number"
                                          :disabled="checkIfCompetitionStarted"
                                        ></Input>
                                        <ButtonGroup
                                          class="d-flex player-button-style"
                                        >
                                          <!-- <Button icon="md-checkmark-circle"
                                        @click="() => playerJerseyStatus(j, i, idx, player.jersey_number)"></Button> -->
                                          <Button
                                            @click="
                                              removePlayer(
                                                cat.category,
                                                item.players,
                                                idx,
                                                cat.licenses,
                                                j
                                              )
                                            "
                                            style="border-radius: 0 4px 4px 0"
                                            type="error"
                                            icon="md-trash"
                                            :disabled="player.regStatus"
                                          ></Button>
                                        </ButtonGroup>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </div>
                  </Card>
                </template>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import PlayerSelector from "./PlayerSelector.vue";

export default {
  components: { PlayerSelector },
  data() {
    return {
      categories: [],
      cats: [],
      licenses: [],
      competition: null,
      loading: false,
      user: null,
      catvals: [],
      cantSave: false,
      checkIfCompetitionStarted: false,
      visible: false,
      unavailablePlayers: []
    };
  },
  watch: {
    // licenses: {
    //   handler: function (val, oldVal) {
    //     console.log("oooooooooo", val, oldVal)
    //   },
    //   deep: true
    // }
    cats: {
      deep: true,
      handler(_n) {
        this.changes = true;
      }
    }
  },
  methods: {
    checkMedicalControl(license) {
      if (license.medical_Date < new Date().getFullYear()) {
        return true;
      }
      return false;
    },
    removeNewTeam(teams, index) {
      teams.splice(index, 1);
    },
    removePlayer(category, players, idx, licenses, teamId) {
      const removedPlayers = players.splice(idx, 1);
      this.cats[teamId].licenses.splice(idx, 0, removedPlayers[0].player);
      this.licenseFilter(category, licenses);
    },
    checkUniqueJerseyNumbers() {
      for (const cat of this.cats) {
        const teams = cat.teams;

        for (const team of teams) {
          const players = team.players;
          const usedJerseyNumbersByTeam = new Set();
          for (const player of players) {
            const { jersey_number } = player;
            if (jersey_number) {
              if (usedJerseyNumbersByTeam.has(jersey_number.toString())) {
                this.$Message.error({
                  content: this.$t("competition.duplicate_jersey", {
                    jersey: jersey_number,
                    team: team.name,
                    player:
                      player.player.firstName + " " + player.player.secondName
                  }),
                  duration: 15,
                  closable: true
                });
                this.cantSave = true;
                break;
              } else {
                this.cantSave = false;
              }

              usedJerseyNumbersByTeam.add(jersey_number.toString());
            } else if (!players.every(pla => pla.jersey_number === null)) {
              this.cantSave = true;
              this.$Message.error({
                content: this.$t("competition.all_or_none"),
                duration: 15,
                closable: true
              });
              break;
            } else {
              this.cantSave = false;
            }
          }
          console.log(Array.from(usedJerseyNumbersByTeam.values()));
        }
      }
    },
    checkTeamNames() {
      for (let i = 0; i < this.cats.length; i++) {
        const { teams } = this.cats[i];
        for (let j = 0; j < teams.length; j++) {
          const team = teams[j];
          if (!team.nameStatus) {
            this.teamNameState(i, j, true);
          } else {
            this.cantSave = false;
          }
        }
      }
    },
    async onSubmit() {
      this.checkUniqueJerseyNumbers();
      this.checkTeamNames();
      console.log(this.cantSave);
      if (!this.cantSave) {
        this.loading = true;
        try {
          let fullNew = [];
          let emptyNew = [];
          let emptyEdited = [];
          let fullEdited = [];
          for (let i = 0; i < this.cats.length; i++) {
            const element = this.cats[i];
            for (let j = 0; j < element.teams.length; j++) {
              const element1 = element.teams[j];
              if (element1.full) {
                if (element1.hasOwnProperty("_id")) {
                  const pushedFull = await this.$http.post("/team/edit", {
                    _id: element1._id,
                    competition_id: this.competition._id,
                    name: element1.name,
                    players: element1.players,
                    ttype: this.competition.ttype._id,
                    category: element.category._id,
                    clubId: this.user.clubId._id,
                    group: element1.group
                  });
                  fullEdited.push(pushedFull.data.name);
                } else {
                  const pushedFull = await this.$http.post("/team/add", {
                    competition_id: this.competition._id,
                    name: element1.name,
                    players: element1.players,
                    ttype: this.competition.ttype._id,
                    category: element.category._id,
                    clubId: this.user.clubId._id,
                    group: this.competition.stages.map(stage => {
                      return { stage: stage._id };
                    })
                  });
                  fullNew.push(pushedFull.data.name);
                }
              } else if (element1.name) {
                if (element1.hasOwnProperty("_id")) {
                  const pushedNotFull = await this.$http.post("/team/edit", {
                    _id: element1._id,
                    competition_id: this.competition._id,
                    name: element1.name,
                    players: element1.players,
                    ttype: this.competition.ttype._id,
                    category: element.category._id,
                    clubId: this.user.clubId._id,
                    group: element1.group
                  });
                  emptyEdited.push(pushedNotFull.data.name);
                } else {
                  const pushedNotFull = await this.$http.post("/team/add", {
                    competition_id: this.competition._id,
                    name: element1.name,
                    players: element1.players,
                    ttype: this.competition.ttype._id,
                    category: element.category._id,
                    clubId: this.user.clubId._id,
                    group: this.competition.stages.map(stage => {
                      return { stage: stage._id };
                    })
                  });
                  emptyNew.push(pushedNotFull.data.name);
                }
              }
            }
          }
          if (fullNew.length)
            this.$Message.success({
              content: this.$t("competition.registration_success", {
                teams: fullNew.toString()
              }),
              duration: 15,
              closable: true
            });
          if (emptyNew.length)
            this.$Message.warning({
              content: this.$t("competition.registration_fail", {
                teams: emptyNew.toString()
              }),
              duration: 15,
              closable: true
            });
          if (fullEdited.length)
            this.$Message.success({
              content: this.$t("competition.registration_updated", {
                teams: fullEdited.toString()
              }),
              duration: 15,
              closable: true
            });
          if (emptyEdited.length)
            this.$Message.warning({
              content: this.$t("competition.registration_fail", {
                teams: emptyEdited.toString()
              }),
              duration: 15,
              closable: true
            });
          if (
            this.$router.history.current.path !==
            `/competition/${this.competition._id}/team/${this.user.clubId._id}`
          )
            this.$router.push(
              `/competition/${this.competition._id}/team/${this.user.clubId._id}`
            );
          this.getCurrentTeams();
          this.changes = false;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } catch (error) {
          console.log(error);
          this.$Message.error({
            content: error,
            duration: 15,
            closable: true
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      }
    },
    async deleteTeam(_id) {
      try {
        this.$dialog
          .confirm(this.$t("global.confirmDelete"), {
            okText: this.$t("global.yes"),
            cancelText: this.$t("global.no")
          })
          .then(async _dialog => {
            const res = await this.$http.post("/team/delete", { _id });
            if (res.data) {
              this.$Message.success({
                content: this.$t("competition.team_deleted", {
                  team: res.data.team.name
                }),
                duration: 15,
                closable: true
              });
              this.getCurrentTeams();
            }
          })
          .catch(error => {
            console.log(error);
            // this.$Message.error(`${error}`)
          });
      } catch (error) {
        this.$Message.error({
          content: error,
          duration: 15,
          closable: true
        });
      }
    },
    async getCats() {
      try {
        const res = await this.$http.post("/competition/category/list", {});
        this.categories = res.data.filter(el =>
          this.competition.formats.some(
            cat => cat.category._id === el._id && !cat.format_type && !cat.spec
          )
        );
      } catch (error) {
        console.log(error);
      }
    },
    getCurrentUser() {
      const user = localStorage.getItem("user");
      this.user = JSON.parse(user);
    },
    async getCurrentCompetition() {
      try {
        const res = await this.$http.post("/competition/find", {
          _id: this.$route.params.id
        });
        this.competition = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClubTeams() {
      try {
        const res = await this.$http.post("/team/clublist", {
          // clubId: this.team.clubId._id,
          competition_id: this.competition._id
          // category: this.category
        });
        if (res.data.length) {
          let players = res.data.map(item => {
            return [...item.players];
          });
          this.unavailablePlayers = players.flat();
          console.log("unavailable players :>> ", players.flat());
        }
      } catch (error) {
        console.log(error);
      }
    },
    licenseFilter(cat, players) {
      const currentYear = new Date().getFullYear();
      const currentDate = cat.name.includes("Senior")
        ? new Date(currentYear, 11, 31)
        : new Date();
      return players
        .filter(
          athlete =>
            !this.unavailablePlayers.some(
              ({ player }) => player === athlete._id
            )
        )
        .filter(athlete => {
          let birthDate = new Date(athlete.birthday);
          let age = currentDate.getFullYear() - birthDate.getFullYear();
          let monthDiff = currentDate.getMonth() - birthDate.getMonth();
          if (
            (monthDiff < 0 ||
              (monthDiff === 0 &&
                currentDate.getDate() < birthDate.getDate())) &&
            cat.name.includes("Senior")
          ) {
            age--;
          }
          if (cat.name.includes("Senior")) {
            cat.min_age = 16;
          }
          return (
            age >= cat.min_age - 1 &&
            age <= (athlete.sex === 2 ? cat.max_age + 2 : cat.max_age)
          );
        })
        .filter(athlete =>
          athlete.sex === 1 ||
          (athlete.sex === 2 &&
            (cat.name.includes("Senior") || cat.name.includes("U-18")))
            ? athlete.sex === cat.gender
            : true
        )
        .sort(athlete => (this.checkMedicalControl(athlete) ? -1 : 1));
    },
    async onSelectCategory(val) {
      let arr = [];
      let array = [];
      for (let j = 0; j < val.length; j++) {
        const element = val[j];
        array.push(this.categories.find(cat => cat._id === element));
      }
      for (let i = 0; i < array.length; i++) {
        const element = {
          category: array[i],
          teams: [{ name: "", players: [], nameStatus: false, full: false }]
        };
        arr.push(element);
      }
      if (!this.cats.length) this.cats = arr;
      else if (
        !this.cats.some(
          cat => !this.catvals.some(val => cat.category._id === val)
        )
      ) {
        this.cats.push(
          ...arr.filter(
            ar => !this.cats.some(cat => cat.category._id === ar.category._id)
          )
        );
      }
      // this.getPlayers()
      if (this.$route.params.clubId) await this.getCurrentTeams();
    },
    onChangeCategory() {
      if (
        this.cats.some(
          cat => !this.catvals.some(val => cat.category._id === val)
        )
      ) {
        this.cats = this.cats.filter(
          cat => !this.catvals.some(val => cat.category._id !== val)
        );
      }
      if (!this.catvals.length) {
        this.cats = [];
      }
    },
    disabledCheckBox(category) {
      let cat = this.cats.find(elem => elem.category._id === category._id);
      if (!cat) {
        return false;
      }

      if (cat.teams.length > 0) {
        return true;
      }
      return false;
    },
    async onSelectCategoryCheck(val) {
      let arr = [];
      let array = [];

      for (let j = 0; j < val.length; j++) {
        const element = val[j];
        let newCat = this.categories.find(cat => cat._id === element);
        if (newCat) array.push(newCat);
      }
      console.log({ array });
      for (let i = 0; i < array.length; i++) {
        const element = {
          category: array[i],
          teams: [{ name: "", players: [], nameStatus: false, full: false }],
          licenses: [...this.licenses]
        };
        arr.push(element);
      }

      if (!this.cats.length) {
        this.cats = arr;
      } else if (
        !this.cats.some(
          cat => !this.catvals.some(val => cat.category._id === val)
        )
      ) {
        console.log({ arr });

        this.cats.push(
          ...arr.filter(
            ar => !this.cats.some(cat => cat.category._id === ar.category._id)
          )
        );
      }

      if (
        this.cats.some(
          cat => !this.catvals.some(val => cat.category._id === val)
        )
      ) {
        this.cats = this.cats.filter(
          cat => !this.catvals.some(val => cat.category._id !== val)
        );
      }

      if (!this.catvals.length) {
        this.cats = [];
      }
    },
    onIncreaseTeamQty(val) {
      this.cats[val].teams.push({
        name: "",
        players: [],
        nameStatus: false,
        full: false
      });
    },
    teamNameState(index, index1, value) {
      if (value === true) {
        if (
          !this.cats[index].teams[index1].name.includes(
            ` — ${this.user.clubId.name}`
          ) &&
          this.cats[index].teams.length > 1
        ) {
          if (!this.cats[index].teams[index1].name.length) {
            this.cats[index].teams[index1].name += `${index1 + 1} — ${
              this.user.clubId.name
            }`;
          } else {
            this.cats[index].teams[
              index1
            ].name += ` — ${this.user.clubId.name}`;
          }
        } else if (
          !this.cats[index].teams[index1].name.includes(
            ` — ${this.user.clubId.name}`
          ) &&
          this.cats[index].teams.length === 1
        ) {
          this.cats[index].teams[index1].name += `${this.user.clubId.name}`;
        }
      } else if (value === false) {
        if (
          this.cats[index].teams[index1].name.includes(
            ` — ${this.user.clubId.name}`
          )
        ) {
          this.cats[index].teams[index1].name = this.cats[index].teams[
            index1
          ].name
            .split("—")[0]
            .trim();
        } else if (
          this.cats[index].teams[index1].name === `${this.user.clubId.name}`
        ) {
          this.cats[index].teams[index1].name = "";
        }
      }
      this.cats[index].teams[index1].nameStatus = value;
    },
    isElementRepeated(arr, element) {
      let count = 0;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === element) {
          count++;
          if (count > 1) {
            return true;
          }
        }
      }
      return false;
    },
    playerJerseyStatus(index, index1, player, value) {
      let checkerArr = [
        ...this.cats[index].teams[index1].players.map(
          playa => playa.jersey_number
        )
      ];
      if (!this.isElementRepeated(checkerArr, value)) {
        this.cats[index].teams[index1].players[player].jerseyStatus = true;
        if (
          this.cats[index].teams[index1].players.length >=
          this.competition.ttype.max_count
        )
          if (
            this.cats[index].teams[index1].players.every(
              player => player.jerseyStatus
            ) ||
            this.cats[index].teams[index1].players.every(
              player => !player.jerseyStatus
            )
          )
            this.cats[index].teams[index1].full = true;
          else this.cats[index].teams[index1].full = false;
      } else {
        this.cats[index].teams[index1].players[player].jerseyStatus = false;
      }
    },
    addPlayer(teamId, id, val, licenses) {
      if (val) {
        this.cats[teamId].teams[id].players.push({
          player: licenses.find(license => license._id === val),
          jersey_number: null,
          jerseyStatus: false
        });
        this.cats[teamId].licenses = licenses.filter(
          license => license._id !== val
        );
        if (
          this.cats[teamId].teams[id].players.length >=
          this.competition.ttype.max_count
        ) {
          this.cats[teamId].teams[id].full = true;
        } else {
          this.cats[teamId].teams[id].full = false;
        }
      }
    },
    async getPlayers() {
      try {
        const res = await this.$http.post("/license/list", {
          categoryId: "642d3482a76384148ef547a1",
          status: 2
        });
        if (this.user.role.includes("manager"))
          this.licenses = res.data.filter(
            el =>
              (el.hasOwnProperty("extraClubs") &&
                el.extraClubs.length &&
                el.extraClubs.some(
                  club =>
                    club._id.toString() === this.user.clubId._id.toString()
                )) ||
              (el.clubId && el.clubId._id === this.user.clubId._id)
          );
        else this.licenses = res.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCurrentTeams() {
      // this.catvals = this.catvals.length > 0 ? [...this.catvals] : []
      this.catvals = [];
      try {
        const res = await this.$http.post("/team/list", {
          competition_id: this.$route.params.id,
          clubId: this.$route.params.clubId
        });
        if (!res.data.length)
          this.$router.push(`/competition/${this.competition._id}/team`);
        res.data.forEach(el => {
          if (!this.catvals.includes(el.category._id)) {
            this.catvals.push(el.category._id);
          }
        });
        this.cats = this.catvals.map(el => {
          return {
            category: res.data.find(team => team.category._id === el).category,
            teams: res.data
              .filter(team => team.category._id === el)
              .map(team => {
                return {
                  _id: team._id,
                  name: team.name,
                  players: team.players,
                  nameStatus: true,
                  full: team.players.length >= this.competition.ttype.max_count
                };
              }),
            licenses: [
              ...this.licenses.filter(
                license =>
                  !res.data
                    .filter(team => team.category._id === el)
                    .some(team =>
                      team.players.some(
                        player => player.player._id === license._id
                      )
                    )
              )
            ]
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getAllTournamentTeams() {
      try {
        const res = await this.$http.post("/team/list", {
          competition_id: this.$route.params.id
        });
        // this.licenses = this.licenses.filter(
        //   license =>
        //     !res.data.some(team =>
        //       team.players.some(player => player.player._id === license._id)
        //     )
        // );
      } catch (error) {
        console.log(error);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    const addedTeams =
      to.fullPath !==
        `/competition/${this.competition._id}/team/${this.user.clubId._id}` &&
      from.fullPath !== `/competition/${this.competition._id}/team`;
    const deletedTeams =
      to.fullPath !== `/competition/${this.competition._id}/team` &&
      from.fullPath !==
        `/competition/${this.competition._id}/team/${this.user.clubId._id}`;
    if (this.changes === true && (addedTeams || !deletedTeams)) {
      console.log(addedTeams, deletedTeams);
      this.$dialog
        .confirm(this.$t("global.nonSaveConfirm"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          html: true,
          customClass: "mahnung-confirm"
        })
        .then(async _dialog => {
          next();
        })
        .catch(_error => {
          next(false);
        });
    } else {
      next();
    }
  },
  async mounted() {
    this.loading = true;
    await this.getCurrentCompetition();
    await this.getCurrentUser();
    await this.getCats();
    await this.getPlayers();
    await this.getClubTeams();
    await this.getAllTournamentTeams();

    if (this.$route.params.clubId) {
      await this.getCurrentTeams();
    }
    this.loading = false;
    setTimeout(() => {
      this.changes = false;
    }, 0);
    if (this.competition) {
      console.log(Date.parse(this.competition.reg_date[1]) <= Date.now());
      console.log("catinhos", this.cats);
      if (
        Date.parse(this.competition.reg_date[1]) <= Date.now() &&
        !this.cats.length &&
        !this.competition.forceLateReg
      ) {
        console.log("Competition started");
        this.checkIfCompetitionStarted = true;
      }
    }
    console.log(this.cats);
    console.log("competition competition", this.competition);
  }
};
</script>

<style lang="css" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.bracket-custom-style .ivu-spin {
  background: #454751 !important;
  color: #ffffff;
  z-index: 999;
}

.register-header-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.affix-header-fill-available {
  width: -webkit-fill-available;
}

.users-table-view .header-card {
  background: var(--bg-darkness);
  color: var(--text-color);
}

.users-table-view .page-title {
  font-size: 24px;
  font-weight: 600;
}

#users-table {
  border-collapse: inherit;
  border-spacing: 0;
  width: inherit;
  contain: unset;
  table-layout: fixed;
  margin: 24px 16px;
}

.users-table-view .card-body-table {
  overflow-x: scroll;
  height: calc(100vh - 275px);
  padding: 0;
}

.card-body-table .expire {
  background: #ff000047;
}

.card-body-table .todayBirthday {
  background: #8fbc8f75;
}

.card-body-table .tomorrowBirthday {
  background: #ffff0042;
}

#users-table :global(.ivu-tooltip-rel) {
  cursor: pointer;
}

/*.sort-by {*/
/*  display: inline-block;*/
/*  float: right;*/
/*  cursor: pointer;*/
/*}*/

.user-info-btn {
  padding: 5px 10px;
}

.h-fix {
  height: 50px;
  margin-top: 20;
  width: 100%;
}

#users-table td.user-style :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  vertical-align: middle;
}

.team-box {
  width: 100%;
  max-width: 420px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  padding: 10px 8px;
  border: 1px solid #dcdee2;
}

.team-box-item {
  width: 100%;
  max-width: 420px;
  min-width: 332px;
}

.main-content {
  position: relative !important;
}

.yellow {
  border: 2px solid orange;
  background: orange;
  border-radius: 4px;
}

.green {
  border: 2px solid #19be6b;
  background: #19be6b;
  border-radius: 4px;
}

.green > h1,
.yellow > h1 {
  color: white;
}

.team-box > h1 {
  padding: 4px;
}

.edit-icon {
  cursor: pointer;
}

.team-box > button {
  margin-left: 10px;
}

.player-select {
  width: 100%;
}

#users-table td.user-style :global(.ivu-tooltip) {
  width: 205px;
}

#users-table td.user-iban-style :global(.ivu-tooltip) {
  width: 180px;
}

#users-table tr td {
  font-size: 14px !important;
  line-height: 15px;
}

#users-table tr td,
#users-table tr th {
  vertical-align: middle;
  padding: 7px 5px;
  position: relative;
}

#users-table td.user-phone-list :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  max-height: 32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

#users-table td.user-phone-list :global(.ivu-tooltip) {
  width: 129px;
}

.badge-soft-primary {
  background-color: #dbe1f7 !important;
}

.good-rating {
  color: #18be6b;
}

.average-rating {
  color: #ff9a01;
}

.black-list-rating {
  color: #ee4014;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before) {
  color: #18be6b;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before),
.md-checkmark-style :global(.ivu-icon-md-checkmark-circle-outline:before) {
  line-height: 1;
  font-size: 16px;
}

.player-comp-style :global(.ivu-input) {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.player-comp-style .player-button-style button {
  height: 32px;
}

.player-comp-style .player-button-style button:first-child {
  border-radius: 0;
}

.player-comp-style :global(.ivu-input-disabled) {
  color: #495057;
}

.category-checkbox {
  margin: 0 30px 0 0;
  width: 120px;
  height: 60px;
  padding: 20px;
  background: #e3e3e3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-size: 17px;
}

.category-checkbox :global(.ivu-checkbox) {
  display: none !important;
  position: absolute;
  top: -25px;
  left: -25px;
  transform: rotate(45deg);
}

.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner) {
  border-radius: 0;
  width: 50px;
  height: 50px;
  background: #5abb73;
  border-color: #5abb73;
}

.category-checkbox :global(.ivu-checkbox .ivu-checkbox-inner:after) {
  top: auto;
  left: auto;
  bottom: 19px;
  right: 5px;
  transform: rotate(0deg);
  width: 8px;
  height: 15px;
  border: 3px solid #ffffff;
  border-top: 0;
  border-left: 0;
}

.category-checkbox.ivu-checkbox-wrapper-checked {
  border: 3px solid #5abb73;
}

.category-checkbox.ivu-checkbox-wrapper-checked :global(.ivu-checkbox) {
  display: inline-block !important;
}

.alert-competition-started {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin: 0 auto 40px;
  width: 50%;
}

.alert-competition-started :global(.ivu-alert-message) {
  display: flex;
  align-items: center;
}

.medical-control-style {
  font-size: 11px;
  line-height: 1;
  padding: 2px 15px;
  margin-bottom: 0;
}

@media only screen and (max-width: 575.98px) {
  .users-table-view .page-title {
    font-size: 20px;
  }

  .page-title {
    border: none;
  }
}

@media only screen and (max-width: 767.98px) {
  .team-form-page.page-content {
    padding-right: 0;
    padding-left: 0;
  }

  .alert-competition-started {
    width: 100%;
    margin-bottom: 0;
    padding-right: 16px;
  }

  .alert-competition-block {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team/TeamForm.vue